export default [
  '-h',
  '--help'
] as const
